import Setting from './index';
// import SettingServiceScreen from './service';
// import SettingHubScreen from './hub';
// import SettingUserScreen from './user';

const routes = [
  {
    path: '/setting',
    component: Setting,
    service: ['nvo.platform.client'],
  },
  {
    path: '/setting/*',
    component: Setting,
    action: ['read_only', 'manage'],
    service: [
      'nvo.tms.service',
      'nvo.tms.pricing',
      'nvo.platform.location.hub',
      'nvo.platform.usergroup',
      'nvo.platform.user',
    ],
  },
  // {
  //   path: '/setting/service',
  //   component: SettingServiceScreen,
  //   action: ['manage', 'read_only'],
  //   service: 'nvo.tms.service',
  // },
  // {
  //   path: '/setting/hub',
  //   component: SettingHubScreen,
  //   action: ['manage', 'read_only'],
  //   service: 'nvo.tms.location.hub',
  // },
  // {
  //   path: '/setting/user',
  //   component: SettingUserScreen,
  //   action: ['manage', 'read_only'],
  //   service: 'nvo.tms.user',
  // },
];

export default routes;
